import React, { useRef } from 'react';
import { analyticsUtils } from 'utils/analytics-utils';
import { usePromoViewEvent } from '../../hooks';
import { strictBreakpoints } from '../../styles/breakpoints';
import { Section } from '../section';
import { bannerImage, StyledBanner } from './banner-section-styles';
import { BannerProps } from './banner-types';

export const ActionBanner: React.FC<BannerProps> = ({
  elementBlock, elementName, banner, onClick
}) => {
  const bannerRefs = useRef<HTMLDivElement[]>([]);

  const promotions = [{
    name: `${elementBlock} / ${elementName}`,
    creative: elementName,
    position: '0',
  }];

  usePromoViewEvent(bannerRefs, `${elementBlock} / ${elementName}`, promotions);

  const handleBannerClick = () => {
    if (onClick) {
      onClick();
    }

    analyticsUtils.promoClickEvent(elementBlock, promotions[0]);
  };

  return (
    <Section>
      <StyledBanner
        ref={(el: HTMLDivElement | null) => {
          if (el && bannerRefs) bannerRefs.current[0] = el;
        }}
        onClick={handleBannerClick}
      >
        <picture>
          <source
            srcSet={banner.srcD}
            media={strictBreakpoints['--only-largeDesktop']}
          />
          <source
            srcSet={banner.srcD}
            media={strictBreakpoints['--only-desktop']}
          />
          <source
            srcSet={banner.srcT}
            media={strictBreakpoints['--only-tablet']}
          />

          <img
            alt={banner.alt}
            className={bannerImage}
            loading="lazy"
            src={banner.src}
          />
        </picture>
      </StyledBanner>
    </Section>
  );
};
